import { distinct, filter, mergeMap, takeUntil } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';
import {
  Component,
  Inject,
  ElementRef,
  OnInit,
  Renderer2,
  AfterViewInit,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, from, Observable, of, Subject } from 'rxjs';
import { ENVIRONMENT_CONFIG } from '../../../config/environment.config.token';
import { EnvironmentConfig } from '../../../config/environment.config';
import { AuthService, ClinicService, ConfigService, LanguageService, RightSidebarService, UserService } from '../../../services';
import { Role } from '../../core/models/role';
import { NotificationBarComponent } from './notification-bar/notification-bar.component';

const document: any = window.document;

@Component({
  selector: 'meddata-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {

  public config: any = {};
  userImg: string;
  homePage: string;
  profilePage: string;
  isNavbarCollapsed = true;
  flagvalue;
  countryName;
  langStoreValue: string;
  defaultFlag: string;
  isOpenSidebar: boolean;
  private destroy$ = new Subject<void>();
  personClinics$: Observable<any[]>;
  personClinics: any[] = [];
  clinicBranches$: Observable<any[]>;
  currentClinic: any;
  userContact: any;
  currentEmployee: any;
  currentClinicId$: BehaviorSubject<string> = new BehaviorSubject(null);
  currentTenantId$: BehaviorSubject<string> = new BehaviorSubject(null);
  notificationCount: number = 0;

  @ViewChild(NotificationBarComponent) notificationComponent: NotificationBarComponent;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(ENVIRONMENT_CONFIG) private en_config: EnvironmentConfig,
    private renderer: Renderer2,
    public elementRef: ElementRef,
    private rightSidebarService: RightSidebarService,
    private configService: ConfigService,
    private authService: AuthService,
    private userService: UserService,
    private clinicService: ClinicService,
    private router: Router,
    public languageService: LanguageService,
  ) {
  }

  listLang = [
    { text: 'Русский', shortText: 'Рус', flag: 'assets/images/flags/ru.png', lang: 'ru' },
    { text: 'Ўзбекча', shortText: 'Ўзб', flag: 'assets/images/flags/uz.png', lang: 'uz' },
    { text: 'O`zbekcha', shortText: 'O`zb', flag: 'assets/images/flags/uz.png', lang: 'uz-latn' },
    { text: 'Қарақалпақша', shortText: 'Қр', flag: 'assets/images/flags/kk.png', lang: 'ka' },
    { text: 'Qaraqalpaqsha', shortText: 'Qr', flag: 'assets/images/flags/kk.png', lang: 'ka-latn' },
    { text: 'English', shortText: 'Eng', flag: 'assets/images/flags/us.jpg', lang: 'en' },
  ];

  ngOnInit() {
    this.userService.getUserContact().subscribe(s => this.userService.currentUserContact$.next(s));

    this.userService.currentUserContact$.subscribe(a => {
      this.userContact = a;
      if (this.userContact != null && this.userContact.imageName != null) {
        this.userImg = `${this.en_config.env.storageUrl}/api/files/${this.userContact.imageName}/download`;
      }
      else {
        this.userImg = 'assets/images/user/doctor.jpg';
      }
    })
    this.userService.currentEmployeeSubject$.subscribe(a => {
      this.currentEmployee = a;
    })
    this.config = this.configService.configData;
    this.personClinics$ = this.authService.currentUser$
      .pipe(
        filter(user => !!user.personId),
        mergeMap(_ => this.clinicService.getPersonClinics()),
        takeUntil(this.destroy$)
      )
    this.personClinics$.subscribe(v => {
      this.personClinics = [];
      from(v).pipe(distinct(d => d.id)).subscribe(x => this.personClinics.push(x));
    })
    this.clinicBranches$ = this.authService.currentUser$
      .pipe(
        filter(user => !!user.employeeId),
        mergeMap(_ => this.clinicService.getClinicBranches()),
        takeUntil(this.destroy$)
      )
    this.clinicBranches$.subscribe(a => {
      this.currentClinic = a.find(a => a.id == this.currentClinicId$.getValue())
    })
    this.authService.currentUser$
      .pipe(takeUntil(this.destroy$))
      .subscribe(user => {
        this.currentClinicId$.next(user.clinicId);
        this.currentTenantId$.next(user.tenantId);
        if (user.employeeId) {
          this.userService.getCurrentEmployee().subscribe(s => this.userService.currentEmployeeSubject$.next(s));
        }
        if (user.personId) {
          this.userService.getUserPerson().subscribe(s => this.userService.currentPerson$.next(s));
        }
        const userRoles = user.role ?? [];
        const currenturl = this.router.url.split('?')[0];
        const firstString = currenturl.split('/').slice(1)[0];
        if (userRoles.includes(Role.Admin)) {
          this.homePage = 'admin/dashboard/main';
          this.profilePage = 'admin/profile';
          if (firstString != 'admin') {
            this.router.navigate([this.homePage]);//Navigate to admin panel
          }
        }
        else if (userRoles.includes(Role.TenantAdmin)) {
          this.homePage = '/';
          this.profilePage = 'clinic-admin/profile';
        }
        else if (userRoles.includes(Role.Doctor)) {
          this.homePage = '/';
          this.profilePage = 'doctor/profile';
        }
        else if (userRoles.includes(Role.Patient)) {
          this.homePage = 'patient-cabinet/dashboard';
          this.profilePage = 'patient-cabinet/profile';
          if (firstString != 'patient-cabinet') {
            this.router.navigate([this.homePage]);//Navigate to admin panel
          }
        }
      });

    this.langStoreValue = localStorage.getItem('lang');
    const val = this.listLang.filter((x) => x.lang === this.langStoreValue);
    this.countryName = val.map((element) => element.shortText) ?? 'Рус';
    if (val.length === 0) {
      if (this.flagvalue === undefined) {
        this.defaultFlag = 'assets/images/flags/us.jpg';
      }
    } else {
      this.flagvalue = val.map((element) => element.flag);
    }
  }
  get logoUrl() {
    return this.en_config.env.logoUrl ?? 'assets/images/logo_meddata.png';
  }
  ngAfterViewInit() {
    // set theme on startup
    if (localStorage.getItem('theme')) {
      this.renderer.removeClass(this.document.body, this.config.layout.variant);
      this.renderer.addClass(this.document.body, localStorage.getItem('theme'));
    } else {
      this.renderer.addClass(this.document.body, this.config.layout.variant);
    }

    if (localStorage.getItem('menuOption')) {
      this.renderer.addClass(
        this.document.body,
        localStorage.getItem('menuOption')
      );
    } else {
      this.renderer.addClass(
        this.document.body,
        'menu_' + this.config.layout.sidebar.backgroundColor
      );
    }

    if (localStorage.getItem('choose_logoheader')) {
      this.renderer.addClass(
        this.document.body,
        localStorage.getItem('choose_logoheader')
      );
    } else {
      this.renderer.addClass(
        this.document.body,
        'logo-' + this.config.layout.logo_bg_color
      );
    }

    if (localStorage.getItem('sidebar_status')) {
      if (localStorage.getItem('sidebar_status') === 'close') {
        this.renderer.addClass(this.document.body, 'side-closed');
        this.renderer.addClass(this.document.body, 'submenu-closed');
      } else {
        this.renderer.removeClass(this.document.body, 'side-closed');
        this.renderer.removeClass(this.document.body, 'submenu-closed');
      }
    } else {
      if (this.config.layout.sidebar.collapsed === true) {
        this.renderer.addClass(this.document.body, 'side-closed');
        this.renderer.addClass(this.document.body, 'submenu-closed');
      }
    }

    if (this.notificationComponent) {
      this.notificationComponent.notificationsCount.subscribe({
        next: (s) => {
          this.notificationCount = s;
        }
      });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  callFullscreen() {
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  }
  get getCountryNameDisplay() {
    if (this.countryName) {
      return this.countryName;
    }
    return 'Рус';
  }
  setLanguage(shortText: string, lang: string, flag: string) {
    this.countryName = shortText;
    this.flagvalue = flag;
    this.langStoreValue = lang;
    this.languageService.setLanguage(lang);
    this.reloadCurrentRoute();
  }
  mobileMenuSidebarOpen(event: any, className: string) {
    const hasClass = event.target.classList.contains(className);
    if (hasClass) {
      this.renderer.removeClass(this.document.body, className);
    } else {
      this.renderer.addClass(this.document.body, className);
    }
  }
  callSidemenuCollapse() {
    const hasClass = this.document.body.classList.contains('side-closed');
    if (hasClass) {
      this.renderer.removeClass(this.document.body, 'side-closed');
      this.renderer.removeClass(this.document.body, 'submenu-closed');
    } else {
      this.renderer.addClass(this.document.body, 'side-closed');
      this.renderer.addClass(this.document.body, 'submenu-closed');
    }
  }

  public toggleRightSidebar(): void {
    this.rightSidebarService.sidebarState
      .subscribe((isRunning) => {
        this.isOpenSidebar = isRunning;
      });

    this.rightSidebarService.setRightSidebar(
      (this.isOpenSidebar = !this.isOpenSidebar)
    );
  }

  logout() {
    this.authService.logout();
  }


  switchToClinic(clinicId: string) {
    this.userService.setActiveClinic(clinicId)
      .subscribe(async () => {
        await this.authService.refresh();
        this.reloadCurrentRoute();
      });
  }
  reloadCurrentRoute() {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigateByUrl(currentUrl);
    });
  }
  getClinicLogo(logo: string) {
    const _logo = logo == null ? 'assets/images/user/user1.jpg' :
      `${this.en_config.env.storageUrl}/api/files/${logo}/download`;
    return _logo;
  }
}
